var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1484 0.556152L2.21094 0.556152C0.998047 0.556152 0.0546875 1.5332 0.0546875 2.7124L0.0546875 12.4155C0.0546875 13.6284 0.998047 14.5718 2.21094 14.5718H5.44531V17.4019C5.44531 17.7388 5.81592 17.9409 6.08545 17.7388L10.2969 14.5718H15.1484C16.3276 14.5718 17.3047 13.6284 17.3047 12.4155V2.7124C17.3047 1.5332 16.3276 0.556152 15.1484 0.556152ZM9.75781 9.45068C9.75781 9.61914 9.62305 9.72021 9.48828 9.72021L4.63672 9.72021C4.46826 9.72021 4.36719 9.61914 4.36719 9.45068V8.91162C4.36719 8.77686 4.46826 8.64209 4.63672 8.64209L9.48828 8.64209C9.62305 8.64209 9.75781 8.77686 9.75781 8.91162V9.45068ZM12.9922 6.21631C12.9922 6.38477 12.8574 6.48584 12.7227 6.48584L4.63672 6.48584C4.46826 6.48584 4.36719 6.38477 4.36719 6.21631V5.67725C4.36719 5.54248 4.46826 5.40771 4.63672 5.40771L12.7227 5.40771C12.8574 5.40771 12.9922 5.54248 12.9922 5.67725V6.21631Z",
    fill: "#2D5049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.c8b1ee81dceafb2c4b016ec3c6497897.svg";
export { ForwardRef as ReactComponent };